import { PAGE_KEY } from './constants';

export const es = {
  [PAGE_KEY]: {
    SEO_TITLE: 'Mis solicitudes | Asistencia | Crehana',
    SEO_DESCRIPTION:
      'Solicita a tu administrador o supervisor de asistencia trabajo de tiempo extra o tiempo compensatorio.',

    PAGE_TITLE: 'Mis solicitudes',
    PAGE_DESCRIPTION:
      'Solicita a tu administrador o supervisor de asistencia trabajo de tiempo extra o tiempo compensatorio.',
    BREADCRUMB_ATTENDANCE: 'Asistencia',
    BREADCRUMB_MY_REQUESTS: 'Mis solicitudes',
    BUTTON_CREATE_REQUEST: 'Crear solicitud',

    TABLE_HEADER_DATE: 'Fecha',
    TABLE_HEADER_SHIFT: 'Turno',
    TABLE_HEADER_OVERTIME: 'Tiempo extra',
    TABLE_HEADER_COMPENSATION: 'Tiempo de compensación',
    TABLE_HEADER_REASON: 'Motivo',
    TABLE_HEADER_STATUS: 'Estado',
    TABLE_HEADER_ACTIONS: 'Acciones',

    STATUS_PENDING: 'Pendiente',
    STATUS_APPROVED: 'Aprobada',
    STATUS_DENIED: 'Denegada',
    STATUS_UPDATED_TOOLTIP:
      'El tiempo final puede ser diferente al solicitado, ya que corresponde al tiempo registrado durante la jornada y a posibles ajustes realizados por el administrador.',

    ACTION_CANCEL: 'Cancelar solicitud',
    ACTION_CANCEL_DISABLED_TOOLTIP:
      'Esta acción no está disponible para solicitudes aprobadas.',

    EMPTY_STATE_TITLE: 'Aún no hay solicitudes creadas',
    EMPTY_STATE_DESCRIPTION: 'Cuando lo hagas se verán reflejadas aquí.',
    TABLE_ERROR_TITLE: 'Ocurrió un error',
    TABLE_ERROR_DESCRIPTION:
      'Haz clic en el botón para reintentar cargar nuevamente.',
    ERROR_STATE_RETRY: 'Reintentar',

    CREATE_DIALOG_TITLE: 'Crear solicitud',
    CREATE_DIALOG_OPEN_DAY_WARNING:
      'La cantidad solicitada podrá ajustarse según el tiempo efectivamente registrado en la asistencia de ese día; si el registro es menor al solicitado, se liquidará únicamente el tiempo registrado.',
    CREATE_DIALOG_DATE_LABEL: 'Fecha',
    CREATE_DIALOG_DATE_PLACEHOLDER: 'Selecciona una fecha',
    CREATE_DIALOG_SHIFT_LABEL: 'Turno',
    CREATE_DIALOG_SHIFT_PLACEHOLDER: 'Selecciona a cuál turno corresponde',
    CREATE_DIALOG_SHIFT_NONE_PLACEHOLDER: 'Este día no tiene turno asignado',
    CREATE_DIALOG_SHIFT_NONE_TOOLTIP:
      'No tienes turnos asignados para esta fecha',
    CREATE_DIALOG_SHIFT_ONE_TOOLTIP:
      'Sólo tienes un turno asignado para esta fecha',
    CREATE_DIALOG_OVERTIME_LABEL: 'Horas extra',
    CREATE_DIALOG_COMPENSATION_LABEL: 'Tiempo a compensar',
    CREATE_DIALOG_AMOUNT_PLACEHOLDER: 'HH:MM',
    CREATE_DIALOG_ROUNDING_PREVIEW:
      'Se registrará como {{value}} según la regla de redondeo activa.',
    CREATE_DIALOG_REASON_LABEL: 'Motivo',
    CREATE_DIALOG_REASON_PLACEHOLDER: 'Cuéntanos el motivo de tu solicitud',
    CREATE_DIALOG_CANCEL: 'Cancelar',
    CREATE_DIALOG_SUBMIT: 'Guardar',

    VALIDATION_REQUIRED: 'Campo requerido.',
    VALIDATION_DATE_REQUIRED: 'Campo requerido.',
    VALIDATION_REASON_REQUIRED: 'Campo requerido.',
    VALIDATION_REASON_MAX_LENGTH:
      'El motivo no puede superar los 250 caracteres.',
    VALIDATION_AMOUNT_FORMAT: 'Ingresa una cantidad de tiempo válida.',
    VALIDATION_AMOUNTS_EXCEED_DAY:
      'La suma de tiempo extra y tiempo a compensar no puede superar 24 horas.',
    VALIDATION_DUPLICATE_REQUEST:
      'Ya existe una solicitud o tiempo extra/reposición aprobado para esta fecha.',
    VALIDATION_SHIFT_REQUIRED: 'Campo requerido.',
    VALIDATION_SHIFT_NOT_RESOLVED:
      'Este día tiene más de un turno. Vuelve a intentarlo eligiendo el turno correcto.',

    DELETE_ALERT_TITLE: 'Cancelar solicitud',
    DELETE_ALERT_DESCRIPTION:
      '¿Deseas cancelar tu solicitud del {{date}}? Al hacerlo, dejará de verse en el listado tanto para ti como para tu administrador.',
    DELETE_ALERT_CONFIRM: 'Cancelar solicitud',
    DELETE_ALERT_CANCEL: 'Volver',

    TOAST_CREATE_SUCCESS: 'Tu solicitud fue creada.',
    TOAST_DELETE_SUCCESS: 'Tu solicitud fue cancelada.',
    TOAST_ERROR_GENERIC: 'No pudimos procesar tu solicitud. Intenta de nuevo.',

    REQUESTS_ACTION_VIEW_DETAIL: 'Ver detalle',

    REQUEST_DETAIL_DRAWER_TITLE: 'Solicitud del {{date}}',
    REQUEST_DETAIL_CREATED_AT_LABEL: 'Fecha de solicitud',
    REQUEST_DETAIL_REASON_LABEL: 'Motivo',
    REQUEST_DETAIL_OVERTIME_REQUESTED_LABEL: 'Horas extra solicitadas',
    REQUEST_DETAIL_COMPENSATION_REQUESTED_LABEL:
      'Tiempo a compensar solicitado',
    REQUEST_DETAIL_OVERTIME_FINAL_LABEL: 'Horas extra aprobadas',
    REQUEST_DETAIL_COMPENSATION_FINAL_LABEL: 'Tiempo a compensar aprobado',
    REQUEST_DETAIL_RESPONDED_BY_LABEL: 'Respondido por',
    REQUEST_DETAIL_COMMENTS_THREAD_TITLE: 'Hilo',
    REQUEST_DETAIL_COMMENTS_EMPTY: 'Aún no hay disponibles',
    REQUEST_DETAIL_COMMENTS_EMPTY_SUBTITLE:
      'Los comentarios que tu administrador deje sobre esta solicitud van a aparecer aquí.',
    REQUEST_DETAIL_COMMENT_LABEL: 'Agregar comentario',
    REQUEST_DETAIL_COMMENT_PLACEHOLDER:
      'Utiliza este espacio para agregar comentarios sobre esta solicitud.',
    REQUEST_DETAIL_COMMENT_SUBMIT: 'Agregar comentario',
    VALIDATION_COMMENT_MAX_LENGTH:
      'El comentario no puede superar los 150 caracteres.',
  },
};
